import { Injectable } from '@angular/core';

@Injectable()
export class CardListService {
    private _categoryMapColor: string[] = ['rouge', 'orange', 'green', 'blue', 'violet'];

    constructor(
    ) { }

    public getCategColor(rank: number): string {
        let color: string = this._categoryMapColor[Math.abs(rank % this._categoryMapColor.length)];

        return color;
    }

    public hasCategColor(color: string): boolean {
        return color == 'neutral' || this._categoryMapColor.indexOf(color) >= 0;
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/card-list/services/card-list.service.ts